__turbopack_context__.v({
  "actions": "ui-shell-module__J9sI6q__actions",
  "content": "ui-shell-module__J9sI6q__content",
  "notification": "ui-shell-module__J9sI6q__notification",
  "notificationBody": "ui-shell-module__J9sI6q__notificationBody",
  "notificationDotError": "ui-shell-module__J9sI6q__notificationDotError",
  "notificationDotInfo": "ui-shell-module__J9sI6q__notificationDotInfo",
  "notificationDotSuccess": "ui-shell-module__J9sI6q__notificationDotSuccess",
  "notificationDotWarning": "ui-shell-module__J9sI6q__notificationDotWarning",
  "notificationEmpty": "ui-shell-module__J9sI6q__notificationEmpty",
  "notificationFooter": "ui-shell-module__J9sI6q__notificationFooter",
  "notificationList": "ui-shell-module__J9sI6q__notificationList",
  "notificationMarkAll": "ui-shell-module__J9sI6q__notificationMarkAll",
  "notificationTime": "ui-shell-module__J9sI6q__notificationTime",
  "notificationTitle": "ui-shell-module__J9sI6q__notificationTitle",
  "notificationUnreadCount": "ui-shell-module__J9sI6q__notificationUnreadCount",
  "notificationUnreadRow": "ui-shell-module__J9sI6q__notificationUnreadRow",
  "notificationViewAll": "ui-shell-module__J9sI6q__notificationViewAll",
  "panelContent": "ui-shell-module__J9sI6q__panelContent",
  "panelText": "ui-shell-module__J9sI6q__panelText",
  "panelTitle": "ui-shell-module__J9sI6q__panelTitle",
  "searchInput": "ui-shell-module__J9sI6q__searchInput",
  "unreadDot": "ui-shell-module__J9sI6q__unreadDot",
});
